import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/committees" exact component={List} />
		<Route path="/admin/committees/create" component={Edit} />
		<Route path="/admin/committees/:id" component={Edit} />
	</Switch>
);
